class SmallFormatMenuPanelController {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

const smallFormatMenuPanelComponentDefinition = {
    bindings: {
        navigationItem: '<',
        onClickBack: '&',
        onNavigationItemSelect: '&?',
    },
    controller: ['AnalyticsService', SmallFormatMenuPanelController],
    template: require('./small-format-menu-panel.component.html').trim(),
};

module.exports = {
    SmallFormatMenuPanelController,
    smallFormatMenuPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/smallformatmenu/small-format-menu-panel.component.js